import * as yup from 'yup';

export const getSchema = () =>
  yup.object({
    country: yup.string().required(),
    code: yup.string().trim().required(),
    store: yup.string().required(),
    store_name: yup.string().trim().required(),
  });

export interface ParametricStoreFormValues {
  country: string;
  code: string;
  store: string;
  store_name: string;
}
